module.exports = {"370703001":"寒亭街道","370703002":"开元街道","370703003":"固堤街道","370703006":"高里街道","370703007":"朱里街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370703.json
// module id = 1303
// module chunks = 0